import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";
import { Cart } from "../app-cart";

const divRoot: HTMLDivElement = document.querySelector("#ko-sign-in");
const divModel: HTMLDivElement = document.querySelector("#divUserSignInModel");

export class ViewModel {
    returnUrl: string;

    busy = ko.observable(false);
    email = ko.observable<string>();
    password = ko.observable<string>();

    cart = ko.observable<Cart>();

    submit: () => void

    constructor(model: any) {
        let self = this;

        var data = JSON.parse(model);

        // attempt to overwrite autofill
        //if (data.email)
        //    _.delay(self.email(data.email), 300);

        self.email(data.email);
        self.returnUrl = data.returnUrl;

        if (data.cart) { self.cart(new Cart(data.cart, data.returnUrl)); }

        self.busy.subscribe(newVal => App.busy(newVal));

        self.submit = () => {
            if (!self.busy() && self.validate())
                self.signIn();
        }
    }

    private signIn() {
        let self = this;

        self.busy(true);

        var data = {
            email: self.email(),
            password: self.password(),
            returnUrl: self.returnUrl
        }

        Api.SignIn(data)
            .done(results => {
                if (results.error) { App.alertError(results.message); return; }
                if (results.invalid) { App.alertWarning(results.message); return; }
                window.location.href = results.nextUrl;
            })
            .always(() => self.busy(false));
    }

    private validate(): boolean {
        let self = this;

        if (!App.validateEmail(self.email())) { alert("Invalid Email"); return false; }
        if (!App.hasVal(self.password())) { alert("Invalid Password"); return false; }

        return true;
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());